<template>
  <section>
    <v-container grid-list-xl pt-5 pb-5>
      <h2 class="mx-3 pretopia-head-font">{{ $t('home.companyButtons.title') }}</h2>
      <br />

      <v-tabs class="mx-3">
        <v-tab v-for="category in lookupStore.mainCategories" :key="category.id" class="font-weight-bold">
          {{ category.description }}
        </v-tab>

        <v-tab-item v-for="category in lookupStore.mainCategories" :key="category.id">
          <v-row class="ml-0 mt-4 mb-3">
            <v-btn
              color="secondary"
              class="mr-3 mb-3"
              v-for="company in lookupStore.vendorsForSelectedMainCategory(category.id)"
              :key="company.id"
              @click="$emit('vendor-click', company)"
            >
              {{ company.name }}
            </v-btn>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </section>
</template>

<script>
import { mapStores } from 'pinia';
import { useLookupStore } from '../../../stores/LookupStore';
export default {
  emits: ['vendor-click'],

  computed: {
    ...mapStores(useLookupStore),
  },
};
</script>
